export class RegisterUserModel {
    userName: string;
    password: string;
    firstName: string;
    lastName: string;
    birthDate: Date;
    isMale: boolean;
    RegisterFrom: number = 2;
    usernameType: string = '2';
}